<!-- TODO(ET) - addItemDialogComponent and AddItemComponent should probably be consolidated at this point. AddItemComponent assumes it will only ever exist inside of a dialog. -->
<add-item [description]="description">
</add-item>
